<template>
    <div class="vue--location">
        <input type="hidden" :name="lat.el + '[value]'" v-model="lat_model" class="form-control">
        <input type="hidden" :name="long.el + '[value]'" v-model="long_model" class="form-control">
        <input type="hidden" :name="postcode.el + '[value]'" v-model="postcode_model" class="form-control">
        <input type="hidden" :name="geocode.el + '[value]'" v-model="geocode_model" class="form-control">
        <div class="card card-cascade narrower mb-r">
            <div class="admin-panel info-admin-panel">
                <div data-admin-panel-input--trigger="#entity-type--name,#entity-type--slug"
                     data-admin-panel-input--default-color="primary-color"
                     data-admin-panel-input--danger-color="danger-color"
                     class="admin-panel--header view primary-color">
                    <h5>Location
                        <a tabindex="0" class="white-text" role="button" data-toggle="popover" data-placement="top"
                           data-trigger="focus" title=""
                           data-content="Enter location. drag the pin to correct if necessary"
                           data-original-title="info">
                            <i class="fa fa-question-circle"></i>
                        </a>
                    </h5>
                </div>
                <div class="card-body">
                    <div class="pac-card" :id="elms.card.id">
                        <div>
                            <section>
                                <div id="strict-bounds-selector" class="pac-controls">
                                    <div class="form-group">
                                        <input type="checkbox" :id="elms.location_change_type.strict_bounds.id" value=""
                                               v-model="elms.location_change_type.strict_bounds.model"
                                               v-on:change="setBounds()">
                                        <label :for="elms.location_change_type.strict_bounds.id">Strict Bounds</label>
                                    </div>
                                </div>
                            </section>

                        </div>
                        <div id="pac-container">
                            <div class="md-form form-sm">
                                <i class="fa fa-map-marker prefix"></i>
                                <input :id="elms.input_field.id" type="text"
                                       v-model="elms.input_field.model"
                                       v-on:keyup.enter="enterInputTriggered($event)" class="form-control"
                                       placeholder="">
                                <label :for="elms.input_field.id" :class="elms.input_field.class">Search</label>
                            </div>
                        </div>
                    </div>
                    <div class="google-map" :id="elms.map.id"></div>

                    <!--infoWindow-->
                    <div :id="elms.infowindow_content.id">
                        <img :id="elms.infowindow_content.place.icon.id" :src="elms.infowindow_content.place.icon.model"
                             width="16"
                             height="16" id="place-icon">
                        <span :id="elms.infowindow_content.place.name.id"
                              class="title">{{elms.infowindow_content.place.name.model}}</span><br>
                        <span :id="elms.infowindow_content.place.address.id"
                              v-html="elms.infowindow_content.place.address.model"></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
    .google-map {
        width: 100%;
        height: 300px;
        margin: 0 auto;
        background: gray;
    }
</style>
<script>
    // add imports here
    //	import * as VueGoogleMaps from 'vue2-google-maps';
    import {GOOGLEMAPS_API_KEY, NAME_TO_SLUG_UPDATE} from '../../config'

    //ADD JSDOC HERE!!!!!
    export default {
        created() {
        },
        // updated: function () {
        //     this.$nextTick(function () {
        //         // Code that will run only after the
        //         // entire view has been re-rendered
        //         console.log('Code that will run only after the entire view has been re-rendered')
        //     })
        // },
        mounted() {
            let self = this, props = ['lat', 'long', 'postcode', 'geocode'];
            $.each(props, function (index, value) {
                if (self.$parent[value]) {
                    self[value] = {
                        id: self.$parent[value].id,
                        el: self.$parent[value].el,
                        value: (self.$parent[value].hasOwnProperty('value') ? self.$parent[value].value : null)
                    };
                }
            });
            let hasLoadedPreviousValues = false;
            self.$nextTick(function () {
                $.each(['lat', 'long', 'postcode', 'geocode'], function (index, propType) {

                    let modelName = propType + '_model';

                    if (self[propType].value) {
                        //compile the model name
                        let element = $(`#${self[propType].id}`);

                        /**
                         * Set the elements value
                         */
                        element.val(self[propType].value);

                        /**
                         * Set the label as active
                         */
//						$(`label[for="${self[value].id}"]`).addClass('active');

                        /**
                         * Update the model
                         */
                        self[modelName] = self[propType].value;
                        hasLoadedPreviousValues = true;
                    }
                });
                this.initMap();
//				console.log('hasLoadedPreviousValues',hasLoadedPreviousValues,self['geocode'].value);
                if (self['geocode'].value) {
                    let geocode = JSON.parse(self['geocode'].value);

                    self.updateMarker(geocode);
                }
                //$('[data-toggle="popover"]').popover();
            });
        },
        data() {
            return {
                event_children: {},
                autocomplete: null,
                lat: {},
                lat_model: '',
                long: {},
                long_model: '',
                postcode: {},
                postcode_model: '',
                geocode: {},
                geocode_model: '',

                center: {lat: 10.0, lng: 10.0},
                markers: [{
                    position: {lat: 10.0, lng: 10.0}
                }, {
                    position: {lat: 11.0, lng: 11.0}
                }],

                map: {},
                infoWindow: {},
                marker: {},
                elms: {
                    location_change_type: {
                        model: '',
                        id: '',
                        all: {
                            id: 'location_change_type__all',
                            model: null
                        },
                        establishment: {
                            id: 'location_change_type__establishment',
                            model: null
                        },
                        address: {
                            id: 'location_change_type__address',
                            model: null
                        },
                        geocode: {
                            id: 'location_change_type__geocode',
                            model: null
                        },
                        strict_bounds: {
                            id: 'location_change_type__strict_bounds',
                            model: null
                        }
                    },
                    card: {
                        id: 'pac-card',
                        model: null
                    },
                    map: {
                        id: 'map',
                        model: null
                    },
                    input_field: {
                        id: 'pac-input',
                        model: null,
                        class: ''
                    },
                    type_selector: {
                        id: 'type-selector',
                        model: []
                    },
                    strict_bounds_selector: {
                        id: 'strict-bounds-selector',
                        model: null
                    },
                    infowindow_content: {
                        id: 'infowindow_content',
                        model: null,
                        place: {
                            icon: {
                                id: 'infowindow_content_place__icon',
                                model: null
                            },
                            name: {
                                id: 'infowindow_content_place__name',
                                model: null
                            },
                            address: {
                                id: 'infowindow_content_place__address',
                                model: null
                            }
                        }
                    },

                }
            }
        },
        methods: {
            enterInputTriggered: function (event) {
                console.log('enter...', event);
            },
            initMap: function () {
                let self = this;

                const mapElement = document.getElementById(self.elms.map.id);
                let geoPosition = {
                    lat: self.lat.value,
                    lng: self.long.value
                };
                self.map = new google.maps.Map(mapElement, {
                    center: geoPosition,
                    zoom: 14
                });
                let card = document.getElementById(self.elms.card.id),
                    input = document.getElementById(self.elms.input_field.id),
                    types = document.getElementById(self.elms.type_selector.id),
                    strictBounds = document.getElementById(self.elms.type_selector.id),
                    infowindowContent = document.getElementById(self.elms.infowindow_content.id);

                //reposition the type selectors on to the map
//				self.map.controls[google.maps.ControlPosition.TOP_RIGHT].push(card);

                self.autoComplete = new google.maps.places.Autocomplete(input);
//
//				// Bind the map's bounds (viewport) property to the self.autoComplete object,
//				// so that the self.autoComplete requests use the current map bounds for the
//				// bounds option in the request.
                self.autoComplete.bindTo('bounds', self.map);
//
                self.infoWindow = new google.maps.InfoWindow();
                // self.readDeviceLocation();

                self.infoWindow.setContent(infowindowContent);
                self.marker = new google.maps.Marker({
                    map: self.map,
                    draggable: true,
                    anchorPoint: new google.maps.Point(0, -29)
                });

//				console.log('marker', marker);

                self.autoComplete.addListener('place_changed', function () {

//					close the infoWindow
                    self.infoWindow.close();
//					hide the marker
                    self.marker.setVisible(false);
//					get place details
                    let place = self.autoComplete.getPlace();

                    if (!place.geometry) {
                        // User entered the name of a Place that was not suggested and
                        // pressed the Enter key, or the Place Details request failed.
                        window.alert("No details available for : '" + place.name + "'");
                        return;
                    }

//					update the marker
                    self.updateMarker(place);
                });

                // Sets a listener on a radio button to change the filter type on Places
                // Autocomplete.
                function setupClickListener(id, types) {
                    var radioButton = document.getElementById(id);
                    radioButton.addEventListener('click', function () {
                        self.autoComplete.setTypes(types);
                    });
                }

//				setupClickListener(self.elms.location_change_type.all.id, []);
//				setupClickListener(self.elms.location_change_type.address.id, ['address']);
//				setupClickListener(self.elms.location_change_type.establishment.id, ['establishment']);
//				setupClickListener(self.elms.location_change_type.geocode.id, ['geocode']);
//
//				strictBounds.addEventListener('click', function () {
//					console.log('Checkbox clicked! New state=' + this.checked, this);
//					self.autoComplete.setOptions({strictBounds: this.checked});
//				});

                /**
                 * Add listener to the draggable pin
                 */
                google.maps.event.addListener(self.marker, 'dragend', function (event) {
                    /**
                     * update the model stuff
                     */
                    self.readGeoData({dragend: self.marker.getPosition()}, function (geoData) {
                        self.updateWindowInfo(geoData);
                        self.infoWindow.open(self.map, self.marker);
                    })
                });

                /**
                 * update the form when a user clicks on a point of interest (a place already shown on the map)
                 */
                google.maps.event.addListener(self.map, 'click', function (event) {
                    self.getPointOfInterest(event);
                });
            },
            updateMarker: function (place) {
                let self = this;
                // If the place has a geometry, then present it on a map.
                if (place.geometry.viewport) {
                    self.map.fitBounds(place.geometry.viewport);
                } else {
                    self.map.setCenter(place.geometry.location);
                    self.map.setZoom(17);  // Why 17? Because it looks good.
                }
                self.marker.setPosition(place.geometry.location);
                self.marker.setVisible(true);

                self.updateWindowInfo(place);

                /**
                 * Load geocoder api and extract info using place_id
                 */
                self.readGeoData({
                        place_id: place.place_id
                    },
                    function (geoData) {

                    })
                self.infoWindow.open(self.map, self.marker);
            },
            /**
             * If a boundry is selected from the radio buttons then set the bounds
             */
            setBounds: function () {
//				console.log('this.elms.type_selector.model', this.elms.type_selector.model);
                //this.autoComplete.setOptions({strictBounds: this.checked});
            },
            readGeoDataElement: function (type, place) {
                switch (type) {
                    case 'postcode':

                        for (let i = 0; i < place.address_components.length; ++i) {
                            let result = place.address_components[i];
                            if ('types' in result) {
                                for (var j = 0; j < result.types.length; j++) {
                                    if (result.types[j] == "postal_code") {
                                        return result.long_name;
                                    }
                                }
                            }
                        }
                        break;
                }
            },
            readGeoData: function (options, callback) {
                let geocoder = new google.maps.Geocoder(),
                    settings = {};

                if ('place_id' in options) {
                    settings = {
                        placeId: options.place_id
                    };
                } else if ('dragend' in options) {
                    settings = {
                        latLng: options.dragend
                    };
                }
                if (settings) {
                    geocoder.geocode(settings, function (results, status) {
                        if (status === 'OK') {
                            return callback(results[0]);
                        } else {
                            return null;
                        }
                    });
                }
                return null;
            },
            updateWindowInfo: function (geoData) {
                // console.log('updateWindowInfo', geoData)
                let self = this, geoLocation;
                try {
                    if (!('icon' in geoData)) {
                        // get all details by id
                        let service = new google.maps.places.PlacesService(self.map);
                        service.getDetails({
                            placeId: geoData.place_id
                        }, function (place, status) {
                            if (status === 'OK') {
                                self.updateWindowInfo(place);
                            } else {
                                throw 'Failed to get details from placeId';
                            }

                        });
                    }
                } catch (e) {
                    console.error('Error getting details:', err);
                }

                /**
                 * When
                 */
                geoLocation = (typeof geoData.geometry.location === 'object') ? geoData.geometry.location : geoData.geometry.location.toJSON();

                self.elms.infowindow_content.place.icon.model = geoData.icon;
                self.elms.infowindow_content.place.name.model = geoData.name;
                self.updateName2Slug(geoData);
//				console.log('geoData',geoData,'geoLocation',geoLocation);
                self.elms.infowindow_content.place.address.model = geoData.adr_address;
                self.geocode_model = JSON.stringify(geoData);
                self.lat_model = geoLocation.lat;
                self.long_model = geoLocation.lng;
                self.postcode_model = self.readGeoDataElement('postcode', geoData);
                self.elms.input_field.model = geoData.name;
                self.elms.input_field.class = 'active';
            },
            /**
             * User has clicked on a point of interest and triggered this. Parsing the event
             * @param event
             * */
            getPointOfInterest: function (event) {
                let self = this;

                if (event.placeId) {
                    event.stop();
                    self.readGeoData({place_id: event.placeId}, function (geoData) {
                        self.updateMarker(geoData);
                        // got the details
//						self.updateWindowInfo(geoData);
//						self.infoWindow.open(self.map, self.marker);
                    })
                }
            },
            /**
             * If the device has location enabled then center the map on the location of the device
             */
            readDeviceLocation: function () {
                let self = this;
//				console.log('navigator', navigator);
                // Try HTML5 geolocation.
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(function (position) {
                        let pos = {
                            lat: position.coords.latitude,
                            lng: position.coords.longitude
                        };

                        self.infoWindow.setPosition(pos);
                        self.infoWindow.setContent('Location found.');
                        // console.log('self.infoWindow',self.infoWindow)
                        // self.infoWindow.open(map);
                        self.map.setCenter(pos);
                    }, function () {
                        console.warn('device location not found. most likely not ssl');
                    });
                } else {
                    // Browser doesn't support Geolocation
                    console.warn('Device browser doesnt support Geolocation');
                }
            },
            updateName2Slug: function (geoData) {
//				console.log('geoData', geoData);
                let name = geoData.name;
                if (!name) {
                    name = geoData.formatted_address;
                }
                vueEventHub.$emit(NAME_TO_SLUG_UPDATE, {text: name})
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/GeoLocation.vue?53197ade